module.exports = __webpack_public_path__ + "assets/img/t23.1b74717a.png";